import React from "react";
import { getStatusBadgeClass, getStatusLabel } from "./utils";

export default function BankAccountsPanel({
  earnings,
  bankAccountForm,
  updateBankAccountField,
  resetBankAccountForm,
  enteredBankCountryCode,
  savingBankAccount,
  handleSaveBankAccount,
  handleDeleteBankAccount,
  handleSetDefaultBankAccount,
  startEditBankAccount,
  isAr,
}) {
  const { bankAccounts } = earnings;

  return (
    <div className="card border-0 shadow-sm mb-4 provider-center__panel-card pc-panel--bank">
      <div className="card-body">
        <div className="pc-section-head mb-3">
          <div className="pc-section-head__left">
            <span className="pc-icon-box pc-icon-box--teal"><i className="bi bi-bank" /></span>
            <h5 className="mb-0">{isAr ? "حسابات IBAN" : "IBAN Bank Accounts"}</h5>
          </div>
          <span className="badge text-bg-light">{bankAccounts.length}</span>
        </div>

        <div className="small text-muted mb-3">
          {isAr
            ? "هذا القسم مخصص فقط للحسابات البنكية المستخدمة في السحب عبر IBAN."
            : "This section is only for bank accounts used with IBAN withdrawals."}
        </div>

        <form onSubmit={handleSaveBankAccount} className="mb-4">
          <div className="row g-3">
            <div className="col-12 col-md-6">
              <label className="form-label">{isAr ? "الاسم الكامل" : "Full Name"}</label>
              <input
                className="form-control"
                value={bankAccountForm.fullName}
                onChange={(event) => updateBankAccountField("fullName", event.target.value)}
                required
              />
            </div>
            <div className="col-12 col-md-6">
              <label className="form-label">IBAN</label>
              <input
                className="form-control"
                value={bankAccountForm.iban}
                onChange={(event) => updateBankAccountField("iban", event.target.value)}
                required
              />
            </div>
            <div className="col-12 col-md-4">
              <label className="form-label">{isAr ? "العملة" : "Currency"}</label>
              <input
                className="form-control"
                value={bankAccountForm.currency}
                onChange={(event) =>
                  updateBankAccountField("currency", event.target.value.toUpperCase())
                }
                maxLength={3}
                placeholder={isAr ? "مثال: USD أو EUR أو ILS" : "Example: USD, EUR, or ILS"}
                required
              />
              <div className="form-text">
                {enteredBankCountryCode === "PS"
                  ? isAr
                    ? "لحسابات فلسطين، أدخل العملة الفعلية التي يقبلها هذا الـ IBAN في البنك، وليس قيمة افتراضية."
                    : "For Palestinian bank accounts, enter the real currency supported by this IBAN, not a default value."
                  : isAr
                    ? "أدخل عملة الحساب البنكي الفعلية كما يستقبلها هذا الـ IBAN."
                    : "Enter the real receiving currency of this bank account IBAN."}
              </div>
            </div>
            <div className="col-12 col-md-4">
              <label className="form-label">{isAr ? "اسم البنك" : "Bank Name"}</label>
              <input
                className="form-control"
                value={bankAccountForm.bankName}
                onChange={(event) => updateBankAccountField("bankName", event.target.value)}
              />
            </div>
            <div className="col-12 col-md-4">
              <label className="form-label">Swift Code</label>
              <input
                className="form-control"
                value={bankAccountForm.swiftCode}
                onChange={(event) => updateBankAccountField("swiftCode", event.target.value)}
              />
            </div>
            <div className="col-12 col-md-4">
              <label className="form-label">{isAr ? "العنوان" : "Address"}</label>
              <input
                className="form-control"
                value={bankAccountForm.addressLine}
                onChange={(event) => updateBankAccountField("addressLine", event.target.value)}
              />
            </div>
            <div className="col-12 col-md-4">
              <label className="form-label">{isAr ? "المدينة" : "City"}</label>
              <input
                className="form-control"
                value={bankAccountForm.city}
                onChange={(event) => updateBankAccountField("city", event.target.value)}
              />
            </div>
            <div className="col-12 col-md-4">
              <label className="form-label">{isAr ? "الرمز البريدي" : "Postal Code"}</label>
              <input
                className="form-control"
                value={bankAccountForm.postalCode}
                onChange={(event) => updateBankAccountField("postalCode", event.target.value)}
              />
            </div>
            <div className="col-12 col-md-4">
              <label className="form-label">{isAr ? "الحالة" : "Status"}</label>
              <select
                className="form-select"
                value={bankAccountForm.status}
                onChange={(event) => updateBankAccountField("status", event.target.value)}
              >
                <option value="active">{isAr ? "نشط" : "Active"}</option>
                <option value="inactive">{isAr ? "غير نشط" : "Inactive"}</option>
              </select>
            </div>
            <div className="col-12 col-md-4 d-flex align-items-end">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={Boolean(bankAccountForm.isDefault)}
                  onChange={(event) => updateBankAccountField("isDefault", event.target.checked)}
                  id="provider-bank-default"
                />
                <label className="form-check-label" htmlFor="provider-bank-default">
                  {isAr ? "اجعله افتراضيًا" : "Set as default"}
                </label>
              </div>
            </div>
          </div>

          <div className="d-flex gap-2 mt-3 flex-wrap">
            <button className="btn btn-primary" type="submit" disabled={savingBankAccount}>
              {savingBankAccount
                ? isAr
                  ? "جارٍ الحفظ..."
                  : "Saving..."
                : bankAccountForm.id
                  ? isAr
                    ? "تحديث الحساب"
                    : "Update Bank Account"
                  : isAr
                    ? "إضافة حساب بنكي"
                    : "Add Bank Account"}
            </button>
            {bankAccountForm.id ? (
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={resetBankAccountForm}
              >
                {isAr ? "إلغاء" : "Cancel"}
              </button>
            ) : null}
          </div>
        </form>

        {bankAccounts.length === 0 ? (
          <div className="text-muted small">
            {isAr ? "لا توجد حسابات بنكية محفوظة بعد." : "No bank accounts have been saved yet."}
          </div>
        ) : (
          <div className="row g-3">
            {bankAccounts.map((account) => (
              <div className="col-12 col-md-6" key={account.id}>
                <div className="border rounded-4 p-3 h-100">
                  <div className="d-flex justify-content-between align-items-start gap-3">
                    <div>
                      <div className="fw-semibold">
                        {account.bankName || account.fullName}
                        {account.isDefault ? (
                          <span className="badge text-bg-dark ms-2">
                            {isAr ? "افتراضي" : "Default"}
                          </span>
                        ) : null}
                      </div>
                      <div className="small text-muted">{account.fullName}</div>
                      <div className="small text-muted mt-1">{account.iban}</div>
                      <div className="small text-muted mt-1">
                        {account.countryCode} · {account.currency || "-"}
                      </div>
                      <div className="small mt-2">
                        <span className={`badge rounded-pill ${getStatusBadgeClass(account.status)}`}>
                          {getStatusLabel(account.status, isAr)}
                        </span>
                      </div>
                    </div>

                    <div className="d-flex flex-column gap-2">
                      {!account.isDefault ? (
                        <button
                          type="button"
                          className="btn btn-outline-secondary btn-sm"
                          onClick={() => handleSetDefaultBankAccount(account)}
                        >
                          {isAr ? "افتراضي" : "Make Default"}
                        </button>
                      ) : null}
                      <button
                        type="button"
                        className="btn btn-outline-dark btn-sm"
                        onClick={() => startEditBankAccount(account)}
                      >
                        {isAr ? "تعديل" : "Edit"}
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-danger btn-sm"
                        onClick={() => handleDeleteBankAccount(account)}
                      >
                        {isAr ? "حذف" : "Delete"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
